import { useEffect } from 'react';

export const useIntercom = () => {
  useEffect(() => {
    // eslint-disable-next-line new-cap
    if (typeof window?.Intercom === 'function')
      // eslint-disable-next-line new-cap
      window.Intercom('update', { hide_default_launcher: false });

    return () => {
      // eslint-disable-next-line new-cap
      if (typeof window?.Intercom === 'function')
        // eslint-disable-next-line new-cap
        window.Intercom('update', { hide_default_launcher: true });
    };
  }, []);
};
